<template lang="pug">
  section
    v-text-field(
      readonly
      v-model="p_label"
      label="支払タリフ区分"
      append-outer-icon="search"
      @click:append-outer="openDialog"
      :error-messages="errorHandlerMethod(errorHandlerMethodArgComputed)")

    PagingMasterSelectDialog(ref="dialog" v-on:select:record="selectItem"
      :config="config" :initSearchCond="initSearchCond" :getListActionName="'paymentTariffType/fetchPaymentTariffTypeForSelect'")
</template>

<script>
import ApiHandler from "@/mixin/ApiHandler";
import MasterSelectDialog from "@/mixin/MasterSelectDialog";
import PagingMasterSelectDialog from "@/components/common/PagingMasterSelectDialog";

export default {
  components: { PagingMasterSelectDialog },
  mixins: [ApiHandler, MasterSelectDialog],
  data() {
    return {
      defaultErrorHandlerMethodArg: "paymentTariffTypeId",
      config: {
        title: "支払タリフ区分選択",
        headers: [
          {
            text: "支払タリフ区分名",
            key: "name",
            align: ""
          }
        ],
        width: "50%"
      },
      initSearchCond: () => {
        return {
          name: ""
        };
      }
    };
  }
};
</script>
